import PropTypes from 'prop-types';
import * as React from 'react';
import { createComponent } from '../core/create-component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';
import { Icon } from '../icon/icon.component.js';

const propTypes = {
    /**
   * A localized label which describes the button to screen-reader users
   *
   * Typically it is just a string like "Zoom in"
   */ visuallyHiddenLabel: PropTypes.node,
    /**
   * Serves same purpose as `visuallyHiddenLabel` but accepts only string. In the long run, we prefer this over the former.
   */ accessibleText: PropTypes.string
};
/**
 * @subcomponent ZoomControls
 */ const ZoomControlsIn = createComponent({
    displayName: 'ZoomControlsIn',
    root: 'button',
    propTypes,
    propConfig: {
        classNames: [
            'swan-zoom-controls-in'
        ],
        wrapChildren ({ visuallyHiddenLabel, accessibleText }, _derivedProps, element) {
            const accessibleNode = accessibleText !== null && accessibleText !== undefined ? accessibleText : visuallyHiddenLabel;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, accessibleNode && /*#__PURE__*/ React.createElement(VisuallyHidden, null, accessibleNode), /*#__PURE__*/ React.createElement(Icon, {
                iconType: "zoomIn"
            }), element);
        }
    }
});

export { ZoomControlsIn };
